import { render, staticRenderFns } from "./ShowChat.vue?vue&type=template&id=5fb8c4d5&"
import script from "./ShowChat.vue?vue&type=script&lang=js&"
export * from "./ShowChat.vue?vue&type=script&lang=js&"
import style0 from "./ShowChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports